import { portalApi } from "@services/api/portalApi"

type StudentAuthVUnauthAttendance = {
    totalPossible: number
    totalAttended: number
    attendancePercent: number
    authorisedAbsent: number
    unauthorisedAbsent: number
    authorisedAbsencePercent: number
    unauthorisedAbsencePercent: number
}

export async function fetchStudentAuthVUnauthAttendance(studentNo: string) {
    try {
        const response = await portalApi.get<StudentAuthVUnauthAttendance>(`/students/${studentNo}/attendance/authorisation-summary`)
        return response.data
    } catch (error) {
        console.error("Error fetching student auth vs unauth attendance:", error);
        throw error;
    }
}
